import { CreateOfflineSyncSavedPayload, } from '@standardnotes/models';
import { SyncSignal } from '@Lib/Services/Sync/Signals';
import { OfflineSyncResponse } from './Response';
export class OfflineSyncOperation {
    /**
     * @param payloads  An array of payloads to sync offline
     * @param receiver  A function that receives callback multiple times during the operation
     */
    constructor(payloads, receiver) {
        this.payloads = payloads;
        this.receiver = receiver;
    }
    async run() {
        const responsePayloads = this.payloads.map((payload) => {
            return CreateOfflineSyncSavedPayload(payload);
        });
        const response = new OfflineSyncResponse(responsePayloads);
        await this.receiver(SyncSignal.Response, response);
    }
}
